export const WHATS_NEW_FEATURES = [
  {
    name: 'chatbot',
    title: 'Introducing the ACT AI Customer Service Chatbot',
    description: [
      'A new AI-powered chat assistant is now available for National test events. ' +
        'This chatbot can support your Saturday test event experience from the test event ' +
        'and room pages.',
      'The chatbot is not currently available for Special Testing events.',
      'Click the chat icon in the bottom right to get help during your Saturday test event.',
    ],
  },
];
